import React, { useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import moment from "moment";

import IconButton from "../../../../packages/IconButton";
import WPHeading from "../../../../packages/WPHeading";

import { getLicenseActionMenuOptions } from "../LicenseManagementTable.config";
import { DISABLED_ACTION_IDS } from "./LicenseDropdownActionMenu/constants";
import LicenseDropdownActionMenu from "./LicenseDropdownActionMenu";

import { DATE_FORMATS } from "../../../../constants/global.constants";
import {
  HIDDEN_LICENSE_IDS,
  licenseActionMenuKeys,
} from "../../../../constants/LicenseManagement.constants";

import { MoreIcon } from "../../../../assets/icons";

import {
  shouldDisableLicenseActions,
  shouldDisableTerminateLicense,
} from "../../../../utils/LicenseUtils";

const LicenseLastLoginCellRenderer = ({
  data,
  onActionMenuOption,
  colId,
  node,
}) => {
  const { t } = useTranslation();
  const buttonRef = useRef(null);
  const actualRowIndex = node?.rowIndex;

  const [isActionMenuVisible, setActionMenuVisible] = useState(false);

  const lastLoginDate = data?.lastLogin
    ? moment(data.lastLogin).format(DATE_FORMATS.MMM_DD_YYYY)
    : "";

  // Filter out hidden default licenses so disable logic only evaluates real assignable licenses.
  const filteredLicenses = useMemo(() => {
    if (!Array.isArray(data?.licenses)) return [];
    return data.licenses.filter(
      (license) => !HIDDEN_LICENSE_IDS.includes(Number(license?.id)),
    );
  }, [data?.licenses]);

  const disableLicenseActions = useMemo(
    () => shouldDisableLicenseActions(filteredLicenses),
    [filteredLicenses],
  );

  const translatedMenuOptions = useMemo(() => {
    const availableOptions = getLicenseActionMenuOptions();

    return availableOptions.map((option) => {
      const isDisabled =
        (DISABLED_ACTION_IDS.includes(option.id) && disableLicenseActions) ||
        (option.id === licenseActionMenuKeys.TERMINATE_LICENSE &&
          shouldDisableTerminateLicense(filteredLicenses));

      return {
        ...option,
        label: t(option.label),
        disabled: isDisabled,
      };
    });
  }, [t, disableLicenseActions, filteredLicenses]);

  const handleOptionClick = (option) => {
    if (onActionMenuOption) {
      onActionMenuOption(option.id, data);
    }
  };

  const handleMenuClick = () => {
    setActionMenuVisible((open) => !open);
  };

  return (
    <div
      className="license-menu-container"
      id={`${colId}-container-row-${actualRowIndex}`}
    >
      <WPHeading
        size="small"
        type="default"
        text={lastLoginDate}
        secondary
        fontNoto
        className="license-user-lastLogin"
        id={`${colId}-heading-row-${actualRowIndex}`}
      />
      <IconButton
        ref={buttonRef}
        onClick={handleMenuClick}
        id={`${colId}-menu-row-${actualRowIndex}`}
        className="more-icon-btn"
      >
        <MoreIcon />
      </IconButton>
      <LicenseDropdownActionMenu
        menuOptions={translatedMenuOptions}
        buttonRef={buttonRef}
        isActionMenuVisible={isActionMenuVisible}
        setActionMenuVisible={setActionMenuVisible}
        onOptionClick={handleOptionClick}
      />
    </div>
  );
};

export default LicenseLastLoginCellRenderer;
